var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},_vm.$listeners),[_c('path',{attrs:{"d":"M15.29 12.29 12.7 9.7a1 1 0 0 0-1.41 0L8.7 12.29A1 1 0 0 0 9.41 14h5.18a1 1 0 0 0 .7-1.71"}})])}
var staticRenderFns = []

export { render, staticRenderFns }